import { render, staticRenderFns } from "./show.vue?vue&type=template&id=1e553c87&scoped=true&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=1e553c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e553c87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e553c87')) {
      api.createRecord('1e553c87', component.options)
    } else {
      api.reload('1e553c87', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=1e553c87&scoped=true&", function () {
      api.rerender('1e553c87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/show.vue"
export default component.exports